var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F5F8FF",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 23L22.7022 27.0176C22.8115 27.0722 22.8662 27.0996 22.9235 27.1103C22.9743 27.1198 23.0264 27.1198 23.0772 27.1103C23.1345 27.0996 23.1891 27.0722 23.2985 27.0176L31.3337 23M14.667 27.1666L22.7022 31.1842C22.8115 31.2389 22.8662 31.2662 22.9235 31.277C22.9743 31.2865 23.0264 31.2865 23.0772 31.277C23.1345 31.2662 23.1891 31.2389 23.2985 31.1842L31.3337 27.1666M14.667 18.8333L22.7022 14.8157C22.8115 14.7611 22.8662 14.7337 22.9235 14.723C22.9743 14.7134 23.0264 14.7134 23.0772 14.723C23.1345 14.7337 23.1891 14.7611 23.2985 14.8157L31.3337 18.8333L23.2985 22.8509C23.1891 22.9056 23.1345 22.9329 23.0772 22.9436C23.0264 22.9532 22.9743 22.9532 22.9235 22.9436C22.8662 22.9329 22.8115 22.9056 22.7022 22.8509L14.667 18.8333Z",
    stroke: "#797F8C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.ac456557c298cea674e6dcec245a6d3f.svg";
export { ForwardRef as ReactComponent };